import { Button, Form, Input, message, Row, Col } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { Dispatch } from 'redux';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { IDoctorInfo } from 'src/entity/DoctorEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { fetchDrugStoresIfNeeded, fixDrugStoreSettingData } from 'src/redux/actions/drugStoreCreator';
import I18N from 'src/services/I18NService';
import DoctorService from 'src/services/DoctorService';
import { IStateCollection } from 'src/entity/StateEntity';
import PharmacySetting from 'src/containers/PharmacySetting';
import { IPharmacySettingData, settingDataErrorMsg, pharmacySettingDataHandle } from './PharmacySetting';
import { MallService } from '../../services/MallService';
import { settingData2OnlineData, cloudSettingInfo2Source, localSettingInfo2Source } from 'src/redux/actions/mallPharmacyCreator';
import { IMallPharmacySettingInfo } from 'src/entity/MallEntity';

function hasErrors(fieldsError: any) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

interface ISupplierEditComponentProps extends FormComponentProps {
  isAgent: boolean;
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
  isDomestic: boolean;
  drugStores: IDrugStoreInfo[];
  doctorInfo: IDoctorInfo;
  dispatch: Dispatch<IStateCollection>;
  callback(): void;
}

interface ISupplierEditComponentState {
  /** 是否在线订购 */
  // isOrderOnline: boolean;
  /** 药库设置的数据 */
  settingData: IPharmacySettingData;
  /** 本地药房设置的数据 */
  localSettingData: IMallPharmacySettingInfo[];
  /** 药库设置返回的数据 */
  // resultData: IPharmacySettingResult | undefined;
  /** loading状态 */
  isLoading: boolean;
}

/**
 * 药材供应商编辑组件
 * @class SupplierEditComponent
 * @extends {React.Component<ISupplierEditComponentProps>}
 */
class SupplierEditComponent extends React.Component<ISupplierEditComponentProps, ISupplierEditComponentState> {
  constructor(props: ISupplierEditComponentProps) {
    super(props);

    this.state = {
      settingData: {
        isOrderOnline: false,
        onlineDataList: [],
        offlineDataList: [],
        localDataList: [],
        defaultMedicinePharmacy: undefined,
        defaultPrescriptionPharmacy: undefined,
      },
      localSettingData: [],
      isLoading: false,
    };
  }

  async UNSAFE_componentWillMount() {
    const { doctorInfo, isAgent, drugStores } = this.props;
    if (!!doctorInfo && !!doctorInfo.buyer_user) {
      // 云药房：获取医生的单元药库设置
      const dataPharmacyList = await MallService.getCloudPharmacySetting(doctorInfo.buyer_user);
      // 本地药房：获取医生的单元药库设置
      const localSettingList = await MallService.getLocalPharmacySetting(doctorInfo.buyer_user);
      // 获取医生的默认药库设置
      const configRes = await MallService.getDoctorMedicineConfig(doctorInfo.buyer_user);
      // 完善配药中心的数据
      const dataDrugStoreList = fixDrugStoreSettingData(drugStores, doctorInfo.drug_stores || []);
      // 将请求数据转换为界面所需的数据
      this.setState({
        settingData: {
          isOrderOnline: isAgent && dataDrugStoreList.length > 0,
          onlineDataList: settingData2OnlineData(
            {
              dataDrugStoreList,
              dataPharmacyList,
            },
            drugStores
          ),
          offlineDataList: cloudSettingInfo2Source(dataPharmacyList),
          localDataList: localSettingInfo2Source(localSettingList),
          defaultMedicinePharmacy: !!configRes ? configRes.order_cloud_medicine_group : undefined,
          defaultPrescriptionPharmacy: !!configRes ? configRes.prescription_cloud_medicine_group : undefined,
        },
        localSettingData: localSettingList,
      });
    }
    // 获取代理商的配药中心
    await this.props.dispatch(fetchDrugStoresIfNeeded());
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 药库设置数据更改时回调
   *
   * @memberof SupplierEditComponent
   */
  settingDataChange = (data: IPharmacySettingData) => {
    this.setState({
      settingData: data,
    });
  };

  /**
   * 提交
   *
   * @memberof SupplierEditComponent
   */
  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (this.state.isLoading) {
          return;
        }

        try {
          const { doctorInfo, isAgent, drugStores } = this.props;
          const { settingData } = this.state;
          const errorMsg = settingDataErrorMsg(settingData, drugStores, doctorInfo.location_id);
          if (!!errorMsg) {
            message.error(errorMsg);
            return;
          }
          this.setState({
            isLoading: true,
          });
          if (!!isAgent && !!doctorInfo && !!doctorInfo.id && !!doctorInfo.buyer_user && !!settingData && !errorMsg) {
            let res = true;
            // 1、修改医生的配药中心和业务员
            const orderSetting = pharmacySettingDataHandle(settingData, drugStores);
            res = res && !!(await DoctorService.updateDoctorDrugStore(doctorInfo, orderSetting.drugStoreUUIDList, values.agent_salesman || ''));
            // 2、修改医生的云药房设置
            res = res && !!(await MallService.updateCloudPharmacySetting(doctorInfo.buyer_user, orderSetting.cloudSettingData));
            // 修改医生的本地药房设置
            res = res && !!(await MallService.updateLocalPharmacySetting(doctorInfo.buyer_user, orderSetting.localSettingData));
            // 3、修改医生的默认药库设置
            res =
              res &&
              !!(await MallService.updateDoctorMedicineConfig(
                doctorInfo.buyer_user,
                settingData.defaultMedicinePharmacy || null,
                settingData.defaultPrescriptionPharmacy || null
              ));
            if (!!res) {
              message.success(I18N.get('common_save_success'));
              this.props.callback();
            } else {
              message.error(I18N.get('err_save_failure'));
            }
          }
        } catch (error) {
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_save_failure'));
          }
        } finally {
          this.setState({
            isLoading: false,
          });
        }
      }
    });
  };

  render() {
    const { doctorInfo } = this.props;
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    const { settingData, localSettingData } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={24} style={{ margin: 0 }}>
          <Col span={24} style={{ padding: 0 }}>
            <Form.Item label={I18N.get('common_name')} {...formItemLayout} style={{ marginBottom: '12px' }}>
              {getFieldDecorator(`name`, {
                initialValue: !!doctorInfo ? `${doctorInfo.last_name}${doctorInfo.first_name}` : undefined,
              })(<Input disabled={true} />)}
            </Form.Item>
          </Col>
        </Row>
        <PharmacySetting
          form={this.props.form}
          isEdit={true}
          showExtend={true}
          location={doctorInfo.location_id}
          settingData={settingData}
          localSettingData={localSettingData}
          cbSettingData={this.settingDataChange}
        />
        {
          <Form.Item label={I18N.get('doc_salesman')} {...formItemLayout} style={{ marginBottom: '12px' }}>
            {getFieldDecorator(`agent_salesman`, {
              rules: [{ required: false, message: `${I18N.get('common_input')}${I18N.get('doc_salesman')}` }],
              initialValue: !!doctorInfo ? doctorInfo.agent_salesman : undefined,
            })(<Input />)}
          </Form.Item>
        }
        <Form.Item style={{ textAlign: 'center', marginBottom: '12px' }}>
          <Button type="primary" htmlType="submit" disabled={hasErrors(getFieldsError())}>
            {I18N.get('common_save')}
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const SupplierEditForm = Form.create<ISupplierEditComponentProps>()(SupplierEditComponent);
export default SupplierEditForm;



// WEBPACK FOOTER //
// ./src/components/common/SupplierEditForm.tsx